module.exports = __webpack_public_path__ + "static/media/facebook-f.5df289e0.svg";